<template>
  <div class = 'all-layout-box'>
    <a-layout id="components-layout-demo-top-side-2">



      <!--            头-->
      <a-layout-header class="layout-header-all-box" style="height: 70px">
        <div class="logo">
          <img :src="LOGO" alt="" style="width: 120px;  height: 50px;">
        </div>
        <a-menu
          theme="dark"
          mode="horizontal"

          :default-selected-keys="defaultSelectedKeys0"
          style=" height: 100% "
        >

          <!-- v-if="menuList.includes(item.name)||ismanager"-->
          <a-menu-item v-for="item in headerSubData" v-if="menuList.includes(item.name)||ismanager"

                       :key="item.key" @click=cHeaderMenu(item) style=" height: 100% ">
            <div class="lHeader-menu-single-box">
              <img :src='item.icon' alt="" height="30px">
              <span>{{item.name}}</span>
            </div>

          </a-menu-item>

        </a-menu>

        <div >

          <a-dropdown class="header-right-icon-text" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; margin: 0 5px 0 5px">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()" style="width: 150px;     display: block;    float: left;" >
              <span style="color:white; overflow:hidden;text-overflow:ellipsis; white-space:nowrap; width: 150px; " >当前项目：{{PlatformCurrent.cPlatformName}}  </span>
              <a-icon style="color:white" type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item @click="handleplatform(item)" v-for="item in PlatformList"  style="    display: block;   " >
                <a  >{{item.cPlatformName}}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>


          <a-dropdown class="header-right-icon-text" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; ">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()" style="width: 150px;  display: block;    float: left; " >
              <span style="color:white;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;width: 150px;  ">当前场地：{{SCeneCurrent.cSceneName}} </span><a-icon style="color:white" type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item @click="handlescene(item)" v-for="item in SceneList" style="   display: block;   " >
                <a  >{{item.cSceneName}}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>



        </div>

        <div>
          <a-dropdown class="header-right-icon-text" style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap; ">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()" >
              <span style="color:white;overflow:hidden; text-overflow:ellipsis; white-space:nowrap; ">        {{user.cUserName}} </span><a-icon style="color:white" type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="toHeaderPage('/systemManagement/basicInformation/basicInformationList')">企业信息</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="pwModal">修改密码</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="changeOutVisible">退出登录</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>




        <!--        修改密码弹出框-->
        <a-modal  v-model="pwModalVisible" @ok="pwHandleOk" @cancel="pwHandleCancel" :maskClosable="false" ok-text="确认" cancel-text="取消">
          <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
            <a-form-model-item  label="原密码">
              <a-input v-model="userLoginModel.oldpass" type="text" />
            </a-form-model-item>
            <a-form-model-item  label="新密码">
              <a-input v-model="userLoginModel.password" type="text" />
            </a-form-model-item>
            <a-form-model-item  label="确认密码">
              <a-input v-model="userLoginModel.confirmpass" type="text" />
            </a-form-model-item>

          </a-form-model>
        </a-modal>

        <!--              弹出框-->
        <a-modal v-model="outVisible" title="注销" @ok="handleOk" ok-text="确认" cancel-text="取消">
          <p>是否退出登录？</p>
        </a-modal>


      </a-layout-header>

      <!--            内容-->
      <a-layout>
        <!--                侧边-->
        <a-layout-sider  style="background: #fff;min-height: calc(100vh - 70px)" v-show="siderSubVisible" v-model="collapsed" collapsible>
          <a-menu
            mode="inline"
            :style="{ height: '100%', borderRight: 0}"
            theme="dark"
            @openChange="onOpenChange"
            :selectedKeys=defaultSelectedKeys
          >
            <a-menu-item v-for="item in siderSubData" :key="item.key" @click=cSiderMenu(item)>
              <span ><a-icon :type="item.sidIcon" /><span>{{item.name}}</span></span>
              <!--                            <a-menu-item key="1">-->
              <!--                                option1-->
              <!--                            </a-menu-item>-->
            </a-menu-item>

            <!--                        <a-menu-item>111</a-menu-item>-->
          </a-menu>
        </a-layout-sider>

        <!--                内容-->
        <a-layout style="min-height: calc(100vh - 100px);slex:auto">
          <!--                    <a-breadcrumb style="margin: 16px 0">-->
          <!--                        <a-breadcrumb-item>Home</a-breadcrumb-item>-->
          <!--                        <a-breadcrumb-item>List</a-breadcrumb-item>-->
          <!--                        <a-breadcrumb-item>App</a-breadcrumb-item>-->
          <!--                    </a-breadcrumb>-->
          <a-layout-content
            :style="{
                            // background: '#fff',
                            // padding: '16px',
                            // margin: 0,
                            // minHeight: '280px' min-height:100vh;min-width:100vw;background-color: #002140;flex:auto

                            }"
            style="width:auto"
          >
            <router-view/>
          </a-layout-content>
        </a-layout>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
  // @ is an alias to /src
  // import HelloWorld from '@/components/HelloWorld.vue'
  import Sider from '../components/Sider.vue';
  export default {
    components: {
      Sider
    },
    data() {
      return {
        collapsed: true,
        outVisible:false,
        user:{enterprise:{cEntName:""}},
        PlatformList:[],
        SceneList:[],
        SCeneCurrent:{ID:"",cSceneName:""},
        PlatformCurrent:{ID:"",cPlatformName:""},
        pwModalVisible:false,
        userLoginModel:{},
        menuList:[],
        ismanager:false,
        LOGO:'',
        defaultSelectedKeys0:[],

        // 头部导航
        headerSubData:[
              {
                key:'/largerScreen/largerSiderPage',
                name:"系统主页",
                icon:require("../img/headerMenuIcon/menu/icon13_05.png"),
                link:'/largerScreen/largerSiderPage',
                childrenSub:[

                ]
              },
              {
            key:"/equipment/sence/sceneList",
            name:"设备管理",
            icon:require("../img/headerMenuIcon/menu/icon-1_07.png"),
            childrenSub:[
              {
                key:"/equipment/sence/sceneList",
                name:"场景列表",
                link:"/equipment/sence/sceneList",
                sidIcon:"cloud"
              },
              {
                key:'22',
                name:"设备列表",
                link:"/equipment/equipment/equipmentList",
                childrenSub:[],
                sidIcon:"credit-card"
              },
              {
                key:'23',
                name:"视频列表",
                link:"/video/videoList",
                childrenSub:[],
                sidIcon:"container"
              },

            ]
          },

     /*  */   {
            key:'4',
            name:"能耗分析",
            icon:require("../img/headerMenuIcon/menu/icon-1_12.png"),
            link:"/energyanalsis/energyanalsis",
            childrenSub:[

            ]

          },
          {
            key:'5',
            name:"生产管理",
            icon:require("../img/headerMenuIcon/menu/icon-1_14.png"),
            childrenSub:[
              {
                key:'51',
                name:"工单管理",
                link:"/productionmanagement/workordermanagement/workordermanagementlist",
                // link:"/productionmanagement/workordermanagement/workordermanagementlist",
                childrenSub:[],
                sidIcon:"appstore"
              },
              {
                key:'52',
                name:"农事记录",
                link:"/productionmanagement/farmingrecord/farmingrecordlist",
                childrenSub:[],
                sidIcon:"bulb"
              },


            ]
          },
          {
            key:'6',
            name:"农技服务",
            icon:require("../img/headerMenuIcon/menu/icon-1_16.png"),
            childrenSub:[
              {
                key:'61',
                name:"种植指导",
                link:"/agriculturalServices/plantingInstruction/plantingInstructionList",
                childrenSub:[],
                sidIcon:"appstore"
              },
              {
                key:'62',
                name:"病害虫管理",
                link:"/agriculturalServices/pestManagement/pestManagement",
                childrenSub:[],
                sidIcon:"bulb"
              },
              {
                key:'63',
                name:"产量预测",
                link:"/agriculturalServices/productionForecast/productionForecastList",
                childrenSub:[],
                sidIcon:"book"
              },

            ]
          },
          {
            key:'7',
            name:"项目管理",
            icon:require("../img/headerMenuIcon/menu/icon-1_181.png"),
            childrenSub:[
              {
                key:'71',
                name:"项目管理",
                link:"/platformManagement/platformManagement/platformManagementList",
                childrenSub:[],
                sidIcon:"bank"
              },
              {
                key:'72',
                name:"场地管理",
                link:"/platformManagement/sceneManagement/sceneManagementList",
                childrenSub:[],
                sidIcon:"appstore"
              },
              {
                key:'33',
                name:"设备分配",
                link:"/platformManagement/deviceAllocation/deviceAllocationList",
                childrenSub:[],
                sidIcon:"apartment"
              },
              {
                key:'74',
                name:"视频管理",
                link:"/platformManagement/videoManagement/videoManagementList",
                childrenSub:[],
                sidIcon:"play-square"
              },


            ]
          },
          {
            key:'8',
            name:"系统管理",
            icon:require("../img/headerMenuIcon/menu/icon-1_18.png"),
            childrenSub:[
              {
                key:'81',
                name:"基础信息",
                link:"/systemManagement/basicInformation/basicInformationList",
                childrenSub:[],
                sidIcon:"appstore"
              },
              {
                key:'82',
                name:"操作日志",
                link:"/systemManagement/log/logList",
                childrenSub:[],
                sidIcon:"file-done"
              },
              {
                key:'83',
                name:"用户列表",
                link:"/systemManagement/user/userList",
                childrenSub:[],
                sidIcon:"bulb"
              },
              {
                key:'84',
                name:"权限管理",
                link:"/systemManagement/propertyManagement/propertyList",
                childrenSub:[],
                sidIcon:"cluster"
              },
              // 系统管理-数据配置
              {
                key:'85',
                name:"数据配置",
                link:'/systemManagement/DataConfig/DataConfigForm',

                childrenSub:[],
                sidIcon:"appstore"
              },

            ]
          },

          {
            key:'9',
            name:"数据展示",
            icon:require("../img/headerMenuIcon/menu/icon-1_20.png"),
            link:'/allDataPage/allDataPageList',
            childrenSub:[

            ]
          },

        ],

        // 侧边是否显示
        siderSubVisible:false,

        // 侧边导航内容（默认值）
        siderSubData:[
          // {
          //     key:'11',
          //     name:"场地列表",
          //     childrenSub:[]
          // },
          // {
          //     key:'12',
          //     name:"设备列表",
          //     childrenSub:[]
          // }
        ],

        // 默认侧边选中
        defaultSelectedKeys:['21']

      };
    },
    mounted () {
      let that=this;
   //   this.siderSubData = JSON.parse(     this.$cookies.get("___siderSubData"));
  //
      if(!this.$store.getters.User){
        that.$router.push({ path: '/' });

      }else{
        this.user=this.$store.getters.User
        if (this.$store.getters.User.MenuList){
          this.menuList=this.$store.getters.User.MenuList;
        }
        if (this.$store.getters.User.cRoleName=="管理员"){
          this.ismanager=true;
        }

      }

      this.siderSubData = JSON.parse(     this.$cookies.get("___siderSubData"));
      this.defaultSelectedKeys=  [ this.$cookies.get("this_defaultSelectedKeys")]

      if(! this.$cookies.get("this_defaultSelectedKeys")){

        this.defaultSelectedKeys=[];
      }


this.defaultSelectedKeys0=[    this.$cookies.get("____defaultSelectedKeys0")];

      if(!!this.siderSubData&&this.siderSubData.length){

        this.siderSubVisible = true;
      }

      this.handlePageList();
      this.GetDataConfig();
      console.log('LOGO',this.LOGO);
      if(!this.LOGO){
        this.LOGO= require("../image/logoText.png")
    }
    },
    updated(){
      let that=this;
    //  this.handlePageList();
  //


    //  if(this.siderSubData.length){
      //  this.siderSubVisible = true;
    //    this.defaultSelectedKeys=[i.childrenSub[0].key];

      //  this.$router.push({path:i.childrenSub[0].link})
    //  }
    //  if(!this.siderSubData.length){
   //     this.siderSubVisible = false;
      //  this.$router.push({path:i.link})
      //}
      },
    methods:{
      async GetDataConfig(){
        /*获取项目列表*/

        var that=this
        let res=await that.$http.post('/DataConfig/FindByWhere',{
          cEntID:this.$store.getters.User.enterprise.ID,
          cSystemCode:'设施园艺'
        })


        if(res.data.code=="200"){

          that.EntInfo=res.data.obj.data;

          let _rList=[];
          let cInfos=JSON.parse(that.EntInfo.cInfos)
          that.DeviceID=cInfos.DeviceID;

          if(!!cInfos){


            that.LOGO=cInfos.LOGO


          }
          try{

          }catch (e) {

          }


        }

        if(!this.LOGO){
          this.LOGO= require("../image/logoText.png")
        }
      },
      onOpenChange(openKeys) {
        // const latestOpenKey = openKeys.find(key => this.openKeys.indexOf(key) === -1);
        // if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        //     this.openKeys = openKeys;
        // } else {
        //     this.openKeys = latestOpenKey ? [latestOpenKey] : [];
        // }
      },
      pwModal:function(){
        this.pwModalVisible=true
      },
      async pwHandleOk () {
        let that=this;
        let user=this.utils.deepClone(that.$store.getters.User);
        if (user.cPassword==that.userLoginModel.oldpass){
          if(that.userLoginModel.password=that.userLoginModel.confirmpass){
            user.cPassword=that.userLoginModel.password;

            let res= await that.$http.post('User/Save',user)
            if(res.data.code=="200"){
              that.$message.success('修改成功!')
              this.pwModalVisible=false
            }else {
              that.$message.error('修改失败!')
            }
          }
        }else{
          that.$message.error('原始密码错误!')
        }

      },

      pwHandleCancel:function () {
        this.pwModalVisible=false
      },
      cHeaderMenu:function (i) {
        this.siderSubData = i.childrenSub;
        this.$cookies.set("____defaultSelectedKeys0",i.key,0)
        this.$cookies.set("___siderSubData",JSON.stringify(this.siderSubData ),0)

        if(this.siderSubData.length){
          this.siderSubVisible = true;
          this.defaultSelectedKeys=[i.childrenSub[0].key];

          this.$cookies.set("this_defaultSelectedKeys", this.defaultSelectedKeys,0)



          this.$router.push({path:i.childrenSub[0].link})
        }
        if(!this.siderSubData.length){
          this.siderSubVisible = false;
          this.$router.push({path:i.link})
        }

      },
      cSiderMenu(i){
        if(i.link){
          this.defaultSelectedKeys=[i.key];
          this.$cookies.set("this_defaultSelectedKeys", this.defaultSelectedKeys,0)
          this.$router.push({path:i.link})
        }

        // alert(12345)
      },
      changeOutVisible:function () {
        this.outVisible=true
      },
      toNoticePage:function () {
        this.$router.push('/notice/noticeList')
      },
      toHeaderPage:function (a,vis) {
        if(vis){
          this.$router.push({
            path:a,
            query: {
              backButtonVisible: "1"
            }
          })
        }else{
          this.$router.push(a)
        }
        // this.$router.resolve(a)

      },
      //切换场地
      handleplatform (obj){

        this.$bus.$emit('platformchange', { id:obj.ID});
        this.PlatformCurrent=obj;
        this.handleSceneList(); 
      },
      handlescene(obj){
        this.$bus.$emit('scenechange', { id:obj.ID});
        this.SCeneCurrent=obj;
      },
      async handlePageList(){
        let that=this;
        //let param={cEntID:that.$store.getters.User.enterprise.ID,cSystemCode:'设施园艺'};
		//let res= await that.$http.post('EntPlatformInfo/List',param)
		let param = { cEntID: that.$store.getters.User.enterprise.ID,cSystemCode:'设施园艺',userID:that.$store.getters.User.ID }
        let res= await that.$http.post('EntPlatformInfo/EnterPlatIList',param)

        if(res.data.code=="200"&& res.data.obj.list.length>0){
          that.PlatformList= res.data.obj.list;
          that.PlatformCurrent=that.PlatformList[0];

          that.$store.commit('setPlatForm',that.PlatformList[0]);
          that.handleSceneList();
        }
        else{
          that.$store.commit('setPlatForm',null);
          that.$message.error(res.message)

        }



      },
      async handleSceneList(){
        let that=this;
        let param={cPlatformID:that.PlatformCurrent.ID,cSystemCode:'设施园艺'};
        let res= await that.$http.post('EntSceneInfo/List',param)

        if(res.data.code=="200"){

          if( res.data.obj.list&& res.data.obj.list.length>0) {
            that.SceneList= res.data.obj.list;
            that.SCeneCurrent = that.SceneList[0];
            that.$store.commit('setScene',that.SceneList[0]);



          }else {
            that.SceneList= [];
            that.SCeneCurrent = {ID:"",cSceneName:""};

          }
        }
        else{
          that.$message.error(res.message)

        }
        that.handlescene(that.SCeneCurrent)
      },
      changeOutVisible(){
        this.outVisible=true
      },

      handleOk(){
        this.$router.push({path:"/"})
      }
    }
  };
</script>

<style lang="scss">
  #components-layout-demo-top-side-2 .logo {
    width: 120px;
    height: 31px;
    /*background: rgba(255, 255, 255, 0.2);*/
    /*margin: 16px 28px 16px 0;*/
    /*float: left;*/
  }

  .all-layout-box{
    /*min-height: 100vh;*/
    background-color:#0A2D57;
  }

  .lHeader-menu-single-box{
    height: 100%;
    /*padding: 50px 0;*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 26px;
  }

  .layout-header-all-box{
    width: 100%;
    display: flex;
    color: #0A2D57;
    justify-content: space-between;
  }

  .layout-header-white-box{
    color: white;
  }
</style>
